import toast from 'react-hot-toast';
import getInfoOptions from '../utils/getInfoOptions';
import parseMessage from '../utils/parseMessage';

const info = (message, options) =>
  toast(parseMessage(message), getInfoOptions(options));

export default info;
